/** Maps a stream "kind" to a THEOplayer MIME type, or sniffs the URL. */
const toSourceMimeType = (
  sourceType: string | undefined,
  src: string | undefined,
): string | undefined => {
  if (!sourceType || !src) return sourceType;

  const normalized = sourceType.toLowerCase().trim();

  switch (normalized) {
    case "hls":
    case "m3u8":
    case "application/x-mpegurl":
    case "application/vnd.apple.mpegurl":
      return "application/x-mpegURL";

    case "dash":
    case "mpd":
    case "application/dash+xml":
      return "application/dash+xml";

    case "mp4":
    case "video/mp4":
      return "video/mp4";

    case "ism":
    case "application/vnd.ms-sstr+xml":
      return "application/vnd.ms-sstr+xml";

    default:
      if (src.includes(".m3u8")) return "application/x-mpegURL";
      if (src.includes(".mpd")) return "application/dash+xml";
      if (src.includes(".ism")) return "application/vnd.ms-sstr+xml";
      if (src.includes(".mp4")) return "video/mp4";
      return sourceType;
  }
};

export default toSourceMimeType;
